import React from "react";
import { Text } from "@edricphan2022/uikit";
import { Box } from "@edricphan2022/uikit";
import { useMatchBreakpoints } from "@edricphan2022/uikit";

interface ContentProps {
  text: string;
  title: string;
  isWhite?: boolean;
  isBottom?: boolean;
}

const ContentHeader: React.FC<ContentProps & React.HTMLAttributes<HTMLDivElement>> = ({
  title,
  text,
  isWhite,
  isBottom,
  ...props
}) => {
  const { isTablet } = useMatchBreakpoints();


  return (
    <Box pb="34px">
      {!isBottom && (
        <Text as="h5" color={isWhite ? "#FFFFFF" : "#333333"} fontSize={isTablet ? "18px" : "30px"} lineHeight='1.1'>
          {text}
        </Text>
      )}
      <Text
        as="h2"
        color={isWhite ? "#FFFFFF" : "#333333"}
        fontSize={isTablet ? "32px" : "48px"}
        fontWeight="700"
        fontFamily="ManropeBold"
        lineHeight='1.1'
        {...props}
      >
        {title.toUpperCase()}
      </Text>
      {isBottom && (
        <Text as="h5" color={isWhite ? "#FFFFFF" : "#333333"} fontSize={isTablet ? "16px" : "16px"} {...props}>
          {text}
        </Text>
      )}
    </Box>
  );
};

export default ContentHeader;
